<script lang="ts">
export default { name: 'UsageTypeEmblem' };
</script>

<script setup lang="ts">
import { computed } from 'vue';

import Icon from '@components/Icon.vue';

import { faClockRotateLeft } from '@icons/solid/faClockRotateLeft';
import { faArrowRight } from '@icons/solid/faArrowRight';

export interface Props {
  type: 'historical' | 'projected';
  text?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  text: true,
});

const icon = computed(() => {
  return props.type === 'historical' ? faClockRotateLeft : faArrowRight;
});

const label = computed(() => {
  if (!props.text) {
    return null;
  }

  return props.type === 'historical' ? 'Historical' : 'Projected';
});
</script>

<template>
  <div :class="['usage-type-emblem', type, { 'no-text': !text }]">
    <div class="usage-type-emblem-icon">
      <Icon :icon="icon" />
    </div>

    <div v-if="text" class="usage-type-emblem-label">
      {{ label }}
    </div>
  </div>
</template>

<style lang="scss">
:root {
  --data-historical-color-light: #ffd01c;
  --data-historical-color-dark: #ffd01c;

  --data-projected-color-light: #21bdc0;
  --data-projected-color-dark: #21bdc0;

  @media (prefers-color-scheme: light) {
    --data-historical-color: var(--data-historical-color-light);
    --data-projected-color: var(--data-projected-color-light);
  }

  @media (prefers-color-scheme: dark) {
    --data-historical-color: var(--data-historical-color-dark);
    --data-projected-color: var(--data-projected-color-dark);
  }
}
</style>

<style scoped lang="scss">
@use 'sass:color';

.usage-type-emblem {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 22px;
  border-radius: 1rem;
  user-select: none;

  &.historical {
    color: #6e2a00;
    background-color: var(--data-historical-color) !important;
  }

  &.projected {
    color: #1c2e34;
    background-color: var(--data-projected-color) !important;
  }
}

.usage-type-emblem-icon {
  width: 22px;
  height: 22px;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.usage-type-emblem-label {
  font-size: 0.8rem;
  font-weight: 500;
  padding-right: 0.5rem;
}
</style>
